import React, { Component } from 'react';
import './Categories.css';

const categories = [
  [
    "Транспорт",
    "Автомобили",
    "Мотоциклы и мототехника",
    "Грузовики и спецтехника",
    "Водный транспорт",
    "Запчасти и аксессуары"
  ],
  [
    "Недвижимость",
    "Квартиры",
    "Комнаты",
    "Дома, дачи, коттеджи",
    "Земельные участки",
    "Гаражи и машиноместа",
    "Коммерческая недвижимость",
    "Недвижимость за рубежом"
  ],
  [
    "Работа",
    "Вакансии",
    "Резюме",
    "Услуги",
    "Предложение услуг"
  ],
  [
    "Личные вещи",
    "Одежда, обувь, аксессуары",
    "Детская одежда и обувь",
    "Товары для детей и игрушки",
    "Часы и украшения",
    "Красота и здоровье"
  ],
  [
    "Для дома и дачи",
    "Бытовая техника",
    "Мебель и интерьер",
    "Посуда и товары для кухни",
    "Продукты питания",
    "Ремонт и строительство",
    "Растения",
    "Для бизнеса",
    "Готовый бизнес",
    "Оборудование для бизнеса"
  ],
  [
    "Бытовая электроника",
    "Аудио и видео",
    "Игры, приставки и программы",
    "Настольные компьютеры",
    "Ноутбуки",
    "Оргтехника и расходники",
    "Планшеты и электронные книги",
    "Телефоны",
    "Товары для компьютера",
    "Фототехника"
  ],
  [
    "Хобби и отдых",
    "Билеты и путешествия",
    "Велосипеды",
    "Книги и журналы",
    "Коллекционирование",
    "Музыкальные инструменты",
    "Охота и рыбалка",
    "Спорт и отдых"
  ]
  ,
  [
    "Животные",
    "Собаки",
    "Кошки",
    "Птицы",
    "Аквариум",
    "Другие животные",
    "Товары для животных"
  ]
];

class Categories extends Component {

  renderSection (section, index) {
    return (
      <dl key={index} className="category-map__section">
        {section.map((item, index) =>
          <dt key={item} className={`category-map__category ${!index || item === "Для бизнеса" || item === "Услуги" ? "category-map__root" : ""}`}>
            <a>{item}</a>
          </dt>)}
      </dl>
    );
  }

  render () {
    return (
      <div className="category-map">
        {categories.map((section, index) => this.renderSection(section, index))}
      </div>
    );
  }
}

export default Categories;



// WEBPACK FOOTER //
// ./src/components/Categories/Categories.js